import { getIdToken } from 'firebase/auth';
import { auth } from 'utilities/admin.firebase.utility';

/**
 * Kept for API compatibility with existing callers (e.g. logout).
 *
 * BT-1502: there is no app-level token cache anymore. The Firebase SDK already
 * caches the ID token and refreshes it when it is within 5 minutes of expiring,
 * and it is cleared by the SDK itself on sign-in/sign-out. A second cache keyed
 * on `Date.now()` (instead of the token's real `exp`) is what served expired
 * tokens, so this is intentionally a no-op.
 */
export const clearTokenCache = (): void => {};

/**
 * Get a valid Firebase ID token for the current user.
 *
 * Delegates to the SDK, which returns its cached token while it is still
 * valid and transparently refreshes it otherwise.
 *
 * @param forceRefresh - Skip the SDK cache and fetch a brand new token
 * @returns Promise<string> - Firebase ID token
 * @throws Error if user is not authenticated or token retrieval fails
 */
export const getFirebaseToken = async (forceRefresh = false): Promise<string> => {
  if (!auth.currentUser) {
    throw new Error('User not authenticated');
  }

  try {
    return await getIdToken(auth.currentUser, forceRefresh);
  } catch (error) {
    throw new Error(`Failed to get Firebase token: ${error}`);
  }
};
